import { es } from "vuetify/src/locale";

export default {
  ...es,
  user: "Usuario",
  password: "Contraseña",
  language: "Idioma",
  submit: "Acceso",
  theme: "Tema",
  sessionExits:
    "Ya existe una sesión con ese nombre de usuario. ¿Quieres registrarte de todos modos y destruir la sesión anterior?",
  sessionKill: "Eliminar sesión",
  wrongAuth: "Usuario o contraseña incorrectos",
  userDateExpired: "La licencia de usuario ha caducado",
  dateExpired: "La licencia ha expirado",
  userNoRole: "El usuario no tiene un papel",
  userNoAccess: "El usuario no tiene autorización para el diseñador",
  sessionExpired: "Sesión expirada",
  release: "Liberar",
  autologin: "Inicio de sesión automático",
  blue: "Blue",
  dark: "Darkmode",
  material: "Material",
  quartz: "Quartz",
  horizon: "Horizon",
  client: "Cliente",
};
